import React, {useState, useContext} from 'react'
import PropTypes from 'prop-types'
import DatePicker from "react-datepicker";
import {AiFillWarning} from "react-icons/ai";
import InputMask from 'react-input-mask';
import { BreakPointContext } from "../../contexts/breaking-point";
import t from 'helpers/I18n'

                    
const Picker = ({ getSelected, notBirthdate, noPast, noFuture, enterpriseToCreate }) => {
    const [startDate, setStartDate] = useState(new Date());
    const [maxDate] = useState();
    const range = (start, end) => {
        const ans = [];
        for (let i = start; i <= end; i++) {
            ans.push(i);
        }
        return ans;
    }
    const toDay = new Date()
    const minDate = new Date()
    minDate.setFullYear(minDate.getFullYear() - 18)

      const max100Year = new Date()
    max100Year.setFullYear(max100Year.getFullYear() - 100)

    const enterpriseLimitDate = new Date()
    enterpriseLimitDate.setMonth(enterpriseLimitDate.getMonth() + 4)

    const style = {
        margin: 10,
        display: "flex",
        justifyContent: "center"
    }

    const optionStyle = {
        border:"1px solid red",
    }
    let years = range(toDay.getFullYear() - 100, toDay.getFullYear() - 18)
    if (notBirthdate) years = range(toDay.getFullYear(), toDay.getFullYear() + 100)
    if (noPast) years = range(toDay.getFullYear(), toDay.getFullYear() + 100)
    if (noFuture) years = range(toDay.getFullYear() - 100, toDay.getFullYear())
    if (enterpriseToCreate) years = range(toDay.getFullYear(), new Date(enterpriseLimitDate).getFullYear())
    
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];

    const CustomInput = React.forwardRef(({
        value,
        onClick }, ref) => {
        return <div className="custom-input" onClick={() => {
            onClick()
        }} ref={ref}>
                <div className={`icon fonticons-calendar`} ></div>
            </div>
        }
    );

    const formatDate = (date) => {
        let yyyy = date.getFullYear()
        let mm = date.getMonth() + 1
        let dd = date.getDate()
        return `${dd < 10 ? "0"+dd : dd}/${mm < 10 ? "0"+mm : mm}/${yyyy}`
    }

    return (
        <DatePicker renderCustomHeader={({date,changeYear,changeMonth}) => (
                <div style={style}>
                    <select value={date.getFullYear()} onChange={({ target: { value } }) => changeYear(value)}>
                        {years.map(option => (
                            <option style={optionStyle} key={option} value={option} >
                                {option}
                            </option>
                        ))}
                    </select>
                    <select value={months[date.getMonth()]} onChange={({ target: { value } }) => changeMonth(months.indexOf(value)) }>
                        {months.map(option => (
                            <option key={option} value={option} >
                                {option}
                            </option>
                        ))}
                    </select>
                </div>
            )}
            startDate={maxDate}
            {... (noPast ? { minDate: toDay } : {minDate: max100Year})}
            // {... (notBirthdate ? {} : { maxDate: minDate })}
            {... (noFuture ? { maxDate: toDay } : {})}
            {... (enterpriseToCreate ? {maxDate: enterpriseLimitDate} : {}  )}
            selected={notBirthdate ? startDate : minDate}
            onChange={date => {
                getSelected(formatDate(date))
                setStartDate(date)
            }}
            customInput={<CustomInput />}
        />
    );
};

const DateInput = props => {
    const { name, label, inputValue, inputError, value, onChange, notBirthdate, noPast, enterpriseToCreate, noFuture } = props
    const [error, setError]= useState(inputError)
    const label2 = t("personal_infos.Personal_info_birth_date.place_holder")
    const _className = "textField " + name
    const error_className = error ? "hello-input error" : "hello-input "
    const [invalue, setInvalue] = useState(inputValue || value)
    const breakpoint = useContext(BreakPointContext)

    React.useEffect(() => {
        if (breakpoint.isDesktop || breakpoint.isTablet) {
            setInvalue(value)
       }
     
    }, [value])
    
    const handleChange = (e) => {
        console.log('is typing => ', e)
        checkValue(e)
    }
    
    const checkValue = (e) => {
        const dt = e.target?.value?.includes("/") ? e.target?.value?.split("/") : e.target?.value?.split("-").reverse()
        const validDate = new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate())
        
        let today = new Date()
        today.setDate(today.getDate() - 1)  
        
        const limitEnterpriseDate = new Date()
        limitEnterpriseDate.setMonth(limitEnterpriseDate.getMonth() + 4)

        let minYear = new Date()
        minYear.setFullYear(minYear.getFullYear() - 100)
        minYear.setDate(minYear.getDate() - 1)
    
        const min18Year = new Date()
        min18Year.setFullYear(min18Year.getFullYear() - 18)
                
        const inputDate = dt && new Date(dt[2], dt[1] - 1, dt[0])
        const validFeb = dt && Number(dt[1]) === 2 ? Number(dt[0]) <= 29 ? true : false : true 
                        
        if (e.target?.value !== "") {
            if (notBirthdate) {
                if ((!dt[0]?.includes('_') && (Number(dt[0]) > 31 || Number(dt[0]) === 0)) || 
                    (!dt[1]?.includes('_') && (Number(dt[1]) > 12 || Number(dt[1]) === 0)) ||
                    (!dt[1]?.includes('_') && (!validFeb)) || 
                    (!dt[2]?.includes('_') && (Number(dt[2]) === 0)))
                {
                    setError({error: t("error_messages.date_format")})
                } else {
                    if (enterpriseToCreate) {
                        console.log("donnnnnee")
                        if (inputDate > limitEnterpriseDate || inputDate <= today) {
                            setError({error: t("error_messages.too_young_message")})
                        } else {
                            setError(null)
                        }
                    } else if (noFuture) { 
                        if (inputDate < minYear || inputDate >= today) {
                            setError({error: t("error_messages.too_young_message")})
                        }else {
                            setError(null)
                        }
                    }
                    else {
                    setError(null)
                        
                    }

                }
            } else {
               if (
                    (!dt[0]?.includes('_') && (Number(dt[0]) > 31 || Number(dt[0]) === 0)) ||
                    (!dt[1]?.includes('_') && (Number(dt[1]) > 12 || Number(dt[1]) === 0)) ||
                    (!dt[1]?.includes('_') && (!validFeb)) ||
                    (!dt[2]?.includes('_') && (Number(dt[2]) === 0 )) 
                ) {
                    console.log("age less than 18")
                    setError({error: t("error_messages.date_format")})
                } else if( inputDate <= minYear) {
                    console.log("age more than 100")
                    setError({ error: t("error_messages.too_old_message") })
               } else {
                   setError(null)
                }
            }
            setInvalue(e.target.value)
            onChange(e)
        }
    }
    
    const getSelected = (date) => {
        const e = { target: { value: date } }
        setInvalue(date)
        onChange(e)
    }

    return (
        <>
            <div className={_className}>
                <label className={error_className}>
                    {(breakpoint.isDesktop || breakpoint.isTablet) &&
                    <InputMask mask="99/99/9999"
                        maskplaceholder={"-"}
                        name={name}
                        id={name}
                        value={invalue}
                        onChange={handleChange}
                        placeholder=" "
                        autoComplete="off"
                    />
                    }
    
                    {(!breakpoint.isDesktop && !breakpoint.isTablet) &&
                    <input
                        className="mobile-date-picker"
                        placeholder=" "
                        type={"date"}
                        name={name}
                        id={name}
                        value={invalue}
                        onChange={handleChange}
                    />
                    }
                    <span>
                        <p className={"label2"}>{label}</p>
                        <p className={"label"}>{label2}</p>
                    </span>

                    { error &&
                    <p>
                        <AiFillWarning className={"warning"} size={"1.5em"}/>
                        {error.error}
                        </p>}
                    {(breakpoint.isDesktop || breakpoint.isTablet) &&
                        <Picker getSelected={getSelected} enterpriseToCreate={enterpriseToCreate} notBirthdate={notBirthdate} noFuture={noFuture} noPast={noPast} />
                    }
                    
                </label>
            </div>
        </>
    )
}



DateInput.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    inputValue: PropTypes.any,
    inputError: PropTypes.object,
    value: PropTypes.any,
    onClick: PropTypes.any,
}


export default DateInput